export const ATS_API_URL = process.env.REACT_APP_ATS_API_URL;
export const HIDE_DASHBOARD_HUD_FOR_SUPER_ADMIN = process.env.REACT_APP_HIDE_DASHBOARD_HUD_FOR_SUPER_ADMIN ?? false;
export const REACT_APPLICANT = process.env.REACT_APP_REACT_APPLICANT;
export const MAIN_APP_URL = process.env.REACT_APP_MAIN_APP_URL || "/";
export const ADDRESS_API_KEY = process.env.REACT_APP_ADDRESS_API_KEY;
export const OLD_DOCUPLOAD_API = process.env.REACT_APP_OLD_DOCUPLOAD_API;
export const DOCUPLOAD_SUB_URL_FRONT = process.env.REACT_APP_DOCUPLOAD_SUB_URL_FRONT;
export const ENABLE_PLAID_LINKING = process.env.REACT_APP_ENABLE_PLAID_LINKING === 'true';
export const ENABLE_BULK_DOCUMENT_MOVE_DELETE = process.env.REACT_APP_ENABLE_BULK_DOCUMENT_MOVE_DELETE !== 'false';
export const ARGYLE_VERBOSE_LOGGING =
  process.env.REACT_APP_ARGYLE_VERBOSE_LOGGING === 'true';
export const pk = "pk_live_IaVLDOel1ZP3b76vZKamCSEC";
export const sk = "pk_live_IaVLDOel1ZP3b76vZKamCSEC";
export const SOFTWARE_VERSION=process.env.REACT_APP_SOFTWARE_VERSION || '3.0.5'

// let cachedVersion = null;

// export async function getSoftwareVersion() {
//   if (cachedVersion) return cachedVersion;

//   try {
//     const res = await fetch('/version.json', { cache: 'no-store' });
//     const data = await res.json();
//     cachedVersion = data.version;
//     return cachedVersion;
//   } catch (err) {
//     console.error('Failed to load version.json', err);
//     return 'Unknown';
//   }
// }


export const typesofUsers = {
  superAdmin: "Super Admin",
  admin: "Admin",
  agent: "Agent",
  manager: "Manager",
  applicant: "applicant",
  coApplicant: "Co-applicant",
  coSigner: "Co-signer",
  subscriberUser: "Subscriber User",
  subscriberAdmin: "Subscriber Admin",
  docuverusSuperAdmin: "Docuverus Super Admin",
  landlordThirdPartyAgent: "Landlord Third Party Agent",
  docuverusAdmin: "Docuverus Admin",
};
